import { acpFraudDetectionStates } from './states';

export default (appModule) => {
  appModule.config(acpFraudDetectionStates);
};
